export const appbarHeight = 60
export const footerHeight = 60
export const stikyContent = 55
export const layoutHeight = appbarHeight + footerHeight
export const padding = ".5rem"
export const appbarHeightMobile = 45
export const footerHeightMobile = 40
const vh = "0.00000000000000001px"

export const layoutHeightCards = () => {
  return `calc(${stickyContentHeight} + ${layoutSize()} + ${padding})`
}

export const layoutHeightCardsXS = () => {
  return `calc(${layoutSizeXS()} + ${padding})`
}

export const stickyContentHeight = `${stikyContent}px`

export const layoutSize = () => {
  return `${appbarHeight + footerHeight}px`
}

export const layoutSizeXS = () => {
  return `${appbarHeightMobile + footerHeightMobile + 40}px`
}

export const rvh = () => {
  return `calc(100vh - ${vh})`
}

export const layoutHeightCards4 = () => {
  return `calc(calc(${rvh()} - ${layoutHeightCards()}) / 2)`
}

export const layoutHeightCards4XS = () => {
  return `calc(calc(${rvh()} - ${layoutHeightCardsXS()}) / 2)`
}

export const layoutHeightCards2 = () => {
  return `calc(${rvh()} - ${layoutHeightCards()})`
}

export const layoutHeightCards2XS = () => {
  return `calc(${rvh()} - ${layoutHeightCardsXS()})`
}

export const layoutHeightCards6 = () => {
  return ` calc(calc(${rvh()} - ${layoutHeightCards()}) / 1.99)`
}

export const layoutHeightCards6XS = () => {
  return ` calc(calc(${rvh()} - ${layoutHeightCardsXS()}) / 1.99)`
}

export const maxWidthCard = () => {
  return `calc(calc(${layoutHeightCards4()} * 1.6) * 2)`
}

export const maxWidthCardXS = () => {
  return `calc(calc(${layoutHeightCards4XS()} * 1.6) * 2)`
}

export const authFormWidthMd = "360px"
export const authFormWidthLg = "420px"
export const authFormWidthXl = "480px"

export const authButtonRadius = 2.5
export const authButtonHeight = "48px"
export const authButtonPaddingX = 6
export const authButtonPaddingXCompact = 3
export const authButtonFontSize = "1rem"
export const authButtonFontWeight = 700

export const authCardWidth = 620
export const authCardWidthSuccess = 840
